"use client";

import CookieConsentNotice from "@/components/cookieConsentNotice";
import MetaScripts from "@/components/metaScripts";
import { MixpanelProvider } from "@/contexts/mixpanelContext";
import QueryProvider from "@/contexts/queryContext";
import { configureInterceptor } from "@/utils/configureInterceptors";
import { Toaster } from "@sendsprint/ui-react/components/toast";
import React, { ReactNode, useEffect } from "react";

interface Props {
  children?: ReactNode;
}

const RootLayoutInner = ({ children }: Props) => {
  useEffect(() => {
    configureInterceptor();
  }, []);

  return (
    <QueryProvider>
      <MixpanelProvider>
        {children}
        <Toaster position="bottom-right" />
        <CookieConsentNotice />
        <MetaScripts />
      </MixpanelProvider>
    </QueryProvider>
  );
};

export default RootLayoutInner;
